


















































import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PublicCancelMixin from '@/mixins/public-cancel.mixin';
import { routeName } from '@/constants/route.constants';
import { mapState } from 'vuex';
import { REGISTERED_TAG_MODULE_NAME } from '@/store/modules/registered-tag.module';
import { PayPalVenmoOrderDetails } from '@/models/paypal-venmo-order-details';

@Component({
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, ['orderDetails'])
  }
})
export default class PaymentConfirmationComponent extends mixins(
  PublicCancelMixin
) {
  public createdDate: Date;
  public orderDetails: PayPalVenmoOrderDetails | null;

  public get routeName(): typeof routeName {
    return routeName;
  }

  public created() {
    if (this.orderDetails) {
      this.createdDate = Vue.filter('localTime')(this.orderDetails.orderDate);
    }
  }

  public onScanTagClick() {
    this.$router.replace({ name: routeName.public.scan });
  }

  public onCancelClick() {
    this.onCancel();
  }
}
